export interface MfaRequestResponse {
  resendAvailableAt?: string | Date | null;
}

export const MFA_LOGIN_RESEND_STORAGE_KEY = 'auth.mfa.login.resend';
export const MFA_PROFILE_RESEND_STORAGE_KEY = 'auth.mfa.profile.resend';

export function getMfaCooldownSeconds(resendAvailableAt?: string | Date | null): number {
  if (!resendAvailableAt) {
    return 0;
  }

  return Math.max(0, Math.ceil((new Date(resendAvailableAt).getTime() - Date.now()) / 1000));
}

export function buildMfaCooldownMessage(): string {
  return 'Kod został wysłany.';
}

export function buildMfaResendLabel(seconds: number): string {
  return seconds > 0 ? `Wyślij ponownie za ${seconds} s` : 'Wyślij ponownie kod';
}

export function getMfaResendStorageKey(baseKey: string, scope: string): string {
  return `${baseKey}.${scope}`;
}

export function getStoredMfaCooldownSeconds(baseKey: string, scope: string): number {
  const key = getMfaResendStorageKey(baseKey, scope);
  const resendAvailableAt = sessionStorage.getItem(key);
  if (!resendAvailableAt) {
    return 0;
  }

  const seconds = getMfaCooldownSeconds(resendAvailableAt);
  if (seconds <= 0) {
    sessionStorage.removeItem(key);
  }

  return seconds;
}

export function storeMfaCooldown(baseKey: string, scope: string, resendAvailableAt?: string | Date | null): void {
  const key = getMfaResendStorageKey(baseKey, scope);
  if (!resendAvailableAt) {
    sessionStorage.removeItem(key);
    return;
  }

  sessionStorage.setItem(key, `${resendAvailableAt}`);
}

export function clearStoredMfaCooldown(baseKey: string, scope: string): void {
  sessionStorage.removeItem(getMfaResendStorageKey(baseKey, scope));
}

export function buildMfaResendAvailableAtMessage(resendAvailableAt?: string | Date | null): string {
  if (!resendAvailableAt) {
    return 'Kod został wysłany na adres e-mail.';
  }

  return `Kod został wysłany. Ponowna wysyłka możliwa po: ${new Date(resendAvailableAt).toLocaleString()}`;
}
